import { RiArrowDownSLine } from 'react-icons/ri';

import Text from '@/tayara-kit/Text';

import { IAdAnalytics } from '../../types';

type AdAnalyticsProps = {
  adAnalytics: IAdAnalytics;
};

const ItemAnalytics = ({ adAnalytics }: AdAnalyticsProps) => (
  <div className="w-full grow md:w-full lg:w-[22rem] h-50 px-4 flex flex-col justify-center rounded-lg text-xs  bg-slate-50  text-gray-700 font-medium cursor-pointer hover:drop-shadow border-solid border-[1px] border-slate-200">
    <div className="pt-2 pb-2">
      <div className="flex flex-wrap">
        <Text
          className="flex-1 justify-items-start pb-1 text-xl font-extrabold"
          text={adAnalytics.title}
        />
        <img
          loading="lazy"
          alt="tayara chart icon"
          src="/media/chart-icon.png"
          className="w-30 justify-items-end "
        />
      </div>
      <div className="pt-8 md:pt-10 flex flex-col text-5xl font-black">
        <span className=" text-6xl leading-6">{adAnalytics.value}</span>
        <div className="flex">
          <div className="w-full flex justify-between ">
            <Text
              className="pt-6 w-2/3 text-gray-600 font-light leading-tight text-lg"
              text={adAnalytics.description}
            />
            <div className="flex">
              <span className="self-end mb-1 text-sm text-gray-600 font-bold hover:underline">
                Voir plus
              </span>
              <RiArrowDownSLine
                style={{ marginBottom: '5px', alignSelf: 'end' }}
                size={16}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ItemAnalytics;
